import type { ReactNode } from 'react';
import { PageHeader } from '@/components/common/PageHeader';

export interface BillingPageLayoutProps {
  /** Omitted on the checkout return, which has no page header of its own. */
  title?: string;
  /** Beside the title, e.g. the startup's Premium badge. */
  headerRight?: ReactNode;
  children: ReactNode;
}

/**
 * The width every billing screen sits in.
 *
 * Matches the member pages (Perks, profile editor): a full-width header bar
 * over content held to a centred column, so a plan card does not stretch
 * across a wide monitor.
 */
export function BillingPageLayout({ title, headerRight, children }: BillingPageLayoutProps) {
  return (
    <div className="bg-page-bg min-h-full">
      {title && <PageHeader title={title} rightSlot={headerRight} />}
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 py-10">{children}</div>
    </div>
  );
}
